export const ja = {
  news: 'お知らせ',
  top: 'トップ',
  greeting: 'ごあいさつ',
  about: '日本料理のこと',
  info: 'ご案内',
  seisoka: '青草窠',
  addressTitle: '住所',
  address: '東京都港区南麻布4-2-34',
  telTitle: 'tel',
  tel: '03-3473-3103',
  businessHoursTitle: '営業時間',
  businessHours: '12:00−14:30 / 17:30−23:00',
  holidaysTitle: '定休日',
  sunday: '日曜日',
  howToGo: '東京メトロ日比谷線「広尾駅」より徒歩7分',
  greetingContent: `
    青草窠は2008年に東京・天現寺の境内で開業しました。<br/>
    店名の意は「青々とした草木に囲まれたやすらぎの空間」。北大路魯山人によって篆刻された扁額をカウンターに掲げています。<br/>
    <span class="narrow">茶懐石を基軸に、温故知新を旨として料理を供しています。開業以来、多くの方々に支えられ今日まで歩んで参りました。今後もより一層の高みをめざして精進いたします。</span><br/>
    <br/>
    ハレの日に<br/>
    青草窠の一椀をと<br/>
    思いだされたら<br/>
    お声をかけて下さい<br/>
    <br/>
    「ふたたび訪れたい」と思っていただける店でありたいと願っております。<br/>
  `,
  greetingOwner: '青草窠　永坂早苗',
  aboutContent: `
    日本には美しい四季があります。<br/>
    私たちは山川草木の移ろいに季節を感受し、それに寄り添いながら日々を営んできました。
    日本の気候風土は豊かな自然の恵みをもたらします。まろやかな水、おいしい米、山や海の旬の食材を使った料理を味わい、折々の風物を愛でることができます。<br/>
    日本料理は時代とともに変化と洗練を重ね、千年の時を超え今日も祭りや年中行事、人生の節目に供されます。そして料理のみならずそれを彩る器、しつらえ、さらには建築、庭などが縦糸、横糸となり美しい食文化が紡ぎ出されます。<br/>
    まさしくそれは、青草窠が範とする北大路魯山人に「日本料理は総合芸術だ」と言わしめた所以でしょう。<br/>
  `,
  copyright: '本サイト掲載の記事・写真等の無断複写・複製・転載・<br class="mobile-only">情報システム等への入力を禁じます。',
  menu: {
    dishes: 'お料理',
    omakase: 'おまかせコース',
    lunch: 'ランチ',
    lunchPrice: '7,700円／16,500円（夜のコースのお料理も可）',
    dinner: 'ディナー',
    dinnerPrice: '27,500円／33,000円／38,500円',
    dishesAddition: `
      ※税込、サービス料別途１０％<br/>
      懐石料理、精進料理、ビーガン料理にも対応可能です。
      有機食材を取り入れています。<br class="mobile-only">
      お子様のメニューはアラカルトにて承っております。`,
    beverage: 'お飲み物',
    beerTitle: 'ビール',
    beer: 'サントリー マスターズドリーム',
    sakeTitle: '日本酒',
    sake: '新政／磯自慢／而今／十四代／伯楽星／飛露喜／みむろ杉',
    shochuTitle: '焼酎',
    shochu: '魔王／鬼兜',
    whiskeyTitle: 'ウィスキー',
    whiskey: '山崎／響',
    wineTitle: 'ワイン',
    wine: '日本ワイン／海外ワイン',
    softDrinkTitle: 'ソフトドリンク',
    softDrink: '有機のジュース／ウーロン茶',
    beverageAddition: 'その他各種取り揃えております',
    delivery: '出張料理',
    catering: '懐石・茶事・ケータリング',
    takeoutTitle: 'テイクアウト',
    takeout: '八寸盛込み／土佐あか牛ヒレカツサンド／炊き込みご飯／弁当　等',
    takeoutAddition: 'オーダーメイドにて承りますのでお電話でお尋ねください。',
    sheetsTitle: '御席',
    tearoom: '茶室',
    hinoki: '檜',
    kuri: '栗',
    counter: 'カウンター',
    persons: '名',
    cancelPolicyTitle: 'キャンセルポリシー',
    cancelPolicy: '前日50％　　当日100％のキャンセル料を頂いております。',
    book: '書籍',
    bookTitle: '<div class="book">『晴れの日本料理』</div><div class="book-en">The Seasonal Beauty of Japanese Cuisine</div>',
    bookAddition: '2020年グルマン世界料理本大賞「食の遺産」部門でグランプリ受賞',
  },
}

export const en = {
  news: 'News & Notice',
  top: 'TOP',
  greeting: 'Greetings from SEISOKA',
  about: 'About Japanese cuisine',
  info: 'Information',
  seisoka: 'SEISOKA',
  addressTitle: 'Address',
  address: '4-2-34 Minamiazabu, Minato-ku, Tokyo 106-0047',
  telTitle: 'Tel',
  tel: '+81-3-3473-3103',
  businessHoursTitle: 'Business hours',
  businessHours: '12:00−14:30<br/>17:30−23:00',
  holidaysTitle: 'Regular holiday',
  sunday: 'Sunday',
  howToGo: 'Seven minutes\' walk from Hiroo Station (Exit 1), Hibiya Line, Tokyo Metro.',
  greetingContent: `
    SEISOKA was newly opened in the precincts of Tengenji Temple,<br/>
    Tokyo in 2008. The meaning of its name, SEISOKA, is<br/>
    "a space of peace surrounded by lush vegetation."<br/>
    A horizontal board with the name engraved by Kitaoji Rosanjin himself is hung on the wall behind the restaurant counter.<br/>
    Based on <i>cha-kaiseki</i> (a Japanese meal served at a tea ceremony), dishes are served with the attitude of studying the past to learn new things.<br/>
    SEISOKA has been supported by many customers since its opening and is determined to devote itself to attaining a higher level.<br/>
    <br/>
    On your special celebratory occasions<br/>
    If you happen to remember a taste of SEISOKA<br/>
    Please do let us know<br/>
    <br/>
    Our determination is to continuously endeavor to make SEISOKA a Japanese restaurant you want to come back to.<br/>
  `,
  greetingOwner: 'Sanae Nagasaka<br/>SEISOKA',
  aboutContent: `
    Japan has four beautiful seasons.<br/>
    People have always been discovering and appreciating the beauty of mountains, rivers, grasses and trees, of all the manifestations of nature, of all human feelings as well.
    The climate and natural features of the four seasons of Japan bring us the blessings of nature. We can relish dishes prepared with soft water and seasonal ingredients and appreciate the beauty of things.
    Japanese cuisine, refined with time over a thousand years, is now served at seasonal festivities, annual events and important ceremonies in life. Not only the food itself but also dish plates and bowls,
    settings, architecture and gardens are all important elements that have been playing the roles of the warp and weft in what you might call a fabric of Japanese food culture.<br/>
    It is a harmonious combination of these elements that made Kitaoji Rosanjin say, "Japanese cuisine is the ultimate embodiment of Japanese art culture."<br/>
    In 2013 Japanese food was registered as a UNESCO Intangible Cultural Heritage, which attracted great international attention to Japanese cuisine. Healthful, gastronomic and coexistent with nature, it will be ever loved by people beyond borders.<br/>
    After all this is a Japanese traditional food culture that we should pass on from generation to generation.<br/>
  `,
  copyright: 'Unauthorized copying, reproduction, reprinting, or inputting into an information system of any article,<br class="mobile-only">photograph, or other material published on this site is prohibited.',
  menu: {
    dishes: 'Lunch & Dinner',
    omakase: 'Kaiseki course',
    lunch: 'Lunch',
    lunchPrice: `
      ￥7,700: five dishes, rice and <i>miso soup</i>, <i>maccha</i> and <i>wagashi</i><br>
      ￥16,500 : six dishes, rice and <i>miso soup</i>, <i>maccha</i> and <i>wagashi</i><br>
      (Dinner menu also available)
    `,
    dinner: 'Dinner',
    dinnerPrice: `
      ￥27,500: seven dishes, rice and <i>miso soup</i>, <i>maccha</i> and <i>wagashi</i>, organic fruit jelly<br/>
      ￥33,000: nine dishes, rice and <i>miso soup</i>, <i>maccha</i> and <i>wagashi</i>, organic fruit jelly<br/>
      ￥38,500: nine dishes, aperitif and digestif (non-alcoholic available), rice and <i>miso soup</i>, <i>maccha</i> and <i>wagashi</i>, organic fruit jelly
    `,
    dishesAddition: `
      *Tax included, service charge 10% not included<br/>
      Food material will vary depending on the course and the season.
      The number of dishes can vary depending on the circumstances.
      <i>Cha-kaiseki</i> cuisine, <i>shojin</i> and vegetarian food are available.
      We use organic food.
      For children, a la carte meals are available.
      Special courses are available by order.`,
    beverage: 'Beverage',
    beerTitle: 'Beer',
    beer: 'Suntory Master’s Dream',
    sakeTitle: 'Sake',
    sake: 'Aramasa / Isojiman / Jikon / Juyondai / Hakurakusei / Hiroki / Mimurosugi',
    shochuTitle: 'Shochu',
    shochu: 'Mao / Onikabuto',
    whiskeyTitle: 'Whisky',
    whiskey: 'Yamazaki / Hibiki',
    wineTitle: 'Wine & Champagne',
    wine: 'Japanese / Overseas',
    softDrinkTitle: 'Soft drink',
    softDrink: `
      organic juice / organic oolong tea<br/>
      Mineral water (carbonated / non-carbonated)<br/>
      Non-alcoholic drinks
    `,
    beverageAddition: 'Various other items',
    delivery: 'Cooking at a customer’s home or place',
    catering: 'Kaiseki / <i>Cha-kaiseki</i> course / Catering',
    takeoutTitle: 'Takeaway meals',
    takeout: `
      <i>Hassun</i> dishes / Sandwich of <i>Tosa</i> brown cattle beef filet mignon / <i>Takikomi</i> rice (Cooked rice seasoned with soy sauce, meat or sea food, and other savory vegetables) / Bento (Lunch box)<br/>
      Made-to-order meals
    `,
    takeoutAddition: 'Delivery service available',
    sheetsTitle: 'Tables',
    tearoom: '<i>Chashitsu</i> (traditional tea ceremony room)',
    hinoki: 'Cypress room',
    kuri: 'Chestnut room',
    counter: 'Counter',
    persons: ' persons',
    cancelPolicyTitle: 'Cancellation policy',
    cancelPolicy: '50% cancellation fee for the day before and 100% for on the day will be charged.',
    book: 'Book',
    bookTitle: '<div class="book-en">The Seasonal Beauty of Japanese Cuisine</div>',
    bookAddition: 'received the Grand Prix of Gourmand World Cookbook Awards in the division of "Food Heritage" in 2020.',
  },
}